import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import translationEN from "./eng";
import translationVI from "./vi";

const resources = {
  en: {
    translation: translationEN,
  },
  vi: {
    translation: translationVI,
  },
};

/** Chỉ lấy ngôn ngữ từ URL; không tự ghi localStorage (phải qua functional consent) */
const resolveInitialLng = () => {
  if (typeof window === "undefined") return "en";
  const path = window.location.pathname || "";
  if (path === "/vi" || path.startsWith("/vi/")) return "vi";
  if (path === "/en" || path.startsWith("/en/")) return "en";
  return "en";
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: ["en", "vi"],
    lng: resolveInitialLng(),
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
